import axios from "axios";
// import MockAdapter from "axios-mock-adapter";
// import mockApis from "../__fakeAPI__/customerApi";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const VouchersAPI = axios.create({
  baseURL: apiEndpoint.vouchers,
  headers: {
    "content-type": "application/json",
  },
});

VouchersAPI.interceptors.request.use(refreshInterceptor);

// mockApis(new MockAdapter(VouchersAPI));

export default VouchersAPI;
